module.exports = __webpack_public_path__ + "static/media/insect(31).7746d29f.PNG";